import { makeStyles, shorthands, tokens } from "@fluentui/react-components";

export const useStyles = makeStyles({
  container: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "center",
    ...shorthands.gap("12px"),
    marginBottom: "8px",
    height: "100px",
    ...shorthands.borderWidth("1px"),
    ...shorthands.borderStyle("solid"),
    ...shorthands.borderColor(tokens.colorNeutralStrokeDisabled),
    ...shorthands.borderRadius("8px"),
    ...shorthands.gap("12px"),
    "@media (max-width: 499px)": {
      display: "flex",
      flexDirection: "column",
      marginRight: "12px",
      height: "inherit",
      ...shorthands.padding("0px", "0px", "12px", "0px"),
    },
    "@media (min-width: 500px)": {
      height: "inherit",
      ...shorthands.padding("8px", "16px", "8px", "16px"),
    },
  },
  text: {
    fontFamily: tokens.fontFamilyBase,
    fontSize: tokens.fontSizeBase400,
    fontStyle: "normal",
    fontWeight: tokens.fontWeightSemibold,
    "@media (max-width: 499px)": {
      display: "-webkit-box",
      WebkitBoxOrient: "vertical",
      WebkitLineClamp: 2,
      textOverflow: "ellipsis",
      ...shorthands.overflow("hidden"),
    },
  },
  smallText: {
    fontFamily: tokens.fontFamilyBase,
    fontStyle: "normal",
    fontWeight: tokens.fontWeightRegular,
    "@media (max-width: 499px)": {
      fontSize: tokens.fontSizeBase200,
    },
  },
  price: {
    fontFamily: tokens.fontFamilyBase,
    fontStyle: "normal",
    color: "#707070",
    fontSize: tokens.fontSizeBase300,
    fontWeight: tokens.fontWeightRegular,
    lineHeight: tokens.lineHeightBase300,
  },
  orderSection: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    width: "100%",
    "@media (max-width: 499px)": {
      ...shorthands.padding("12px"),
    },
  },
  rightAlignment: {
    display: "flex",
    flexDirection: "row",
    ...shorthands.gap("17px"),
    "@media (max-width: 600px)": {
      width: "100%",
      display: "flex",
      flexDirection: "column",
    },
  },
  icon: {
    width: "24px",
    height: "24px",
  },
  reorderButton: {
    display: "flex",
    alignItems: "center",
    alignContent: "center",
    "@media (max-width: 600px)": {
      display: "flex",
      justifyContent: "center",
    },
  },
  rightAlignmentButton: {
    display: "flex",
    width: "117px",
    height: "40px",
    ...shorthands.padding("8px", "16px", "8px", "16px"),
    backgroundColor: tokens.colorBrandForeground1,
    color: tokens.colorNeutralForegroundOnBrand,
    "&:disabled": {
      backgroundColor: tokens.colorNeutralBackgroundDisabled,
      color: tokens.colorNeutralForegroundDisabled,
      "&:hover": {
        backgroundColor: tokens.colorNeutralBackgroundDisabled,
        color: tokens.colorNeutralForegroundDisabled,
      },
    },
    "&:hover": {
      backgroundColor: "#5432E6",
      color: tokens.colorNeutralForegroundOnBrand,
    },
    "@media (max-width: 600px)": {
      width: "90%",
    },
  },
  viewDetail: {
    display: "flex",
    alignItems: "center",
    alignContent: "center",
    "@media (max-width: 600px)": {
      display: "flex",
      justifyContent: "center",
    },
  },
  viewDetailsButton: {
    display: "flex",
    width: "118px",
    height: "40px",
    ...shorthands.borderWidth("1px"),
    ...shorthands.borderStyle("solid"),
    ...shorthands.borderRadius("4px"),
    "@media (max-width: 600px)": {
      width: "90%",
    },
  },
  loaderOverlay: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    zIndex: 1000,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "100px",
    height: "100px",
  },
  dialogOverlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 999,
  },
  itemContainerMeasure: {
    display: "flex",
    visibility: "hidden",
    position: "absolute",
    "@media (max-width: 499px)": {
      textOverflow: "ellipsis",
      ...shorthands.overflow("hidden"),
      display: "-webkit-box",
      WebkitBoxOrient: "vertical",
    },
  },
});
